import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Helmet, HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
// const title = "Danial's website";
// const title = "✧˚₊‧ ダニアル・コア ‧₊˚✧";
// const title = "✧˚₊‧ ダニアル ‧₊˚✧";
// const title = "‧₊˚✧ ⎅⏃⋏⟟⏃⌰ ✧˚₊‧";
const title = "𐎠𐏃𐎢𐎼𐎶";

root.render(
  <HelmetProvider>
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>
    </Helmet>

    {/* <React.StrictMode> */}

    <div className="custom-cursor">
      <App style={{ backgroundColor: "#03103f" }} />
    </div>
    {/* </React.StrictMode> */}
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
